export default __webpack_public_path__ + "static/media/Sun.396b6a49.svg";